import { render, staticRenderFns } from "./AnnotationView.vue?vue&type=template&id=0e4ee365&scoped=true&"
import script from "./AnnotationView.vue?vue&type=script&lang=js&"
export * from "./AnnotationView.vue?vue&type=script&lang=js&"
import style0 from "./AnnotationView.vue?vue&type=style&index=0&id=0e4ee365&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4ee365",
  null
  
)

export default component.exports